import { render } from "./DbTableContent.vue?vue&type=template&id=6de9ddf1&scoped=true"
import script from "./DbTableContent.vue?vue&type=script&lang=js"
export * from "./DbTableContent.vue?vue&type=script&lang=js"

import "./DbTableContent.vue?vue&type=style&index=0&id=6de9ddf1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de9ddf1"]])

export default __exports__